import { createIntl as originalCreateIntl, createIntlCache } from "@formatjs/intl";
import { canUseDOM } from "exenv";
import "./utils/intl_polyfill"; // for i18n api on Safari 9

export type SupportedLocales = "ja" | "en";
const DEFAULT_LOCALE = "ja";

function flattenMessages(nestedMessages) {
  const stack = [{ messages: nestedMessages, prefix: null as string | null }];

  const result: { [key: string]: string } = {};

  while (stack.length > 0) {
    const m = stack.pop()!;
    const messages = m.messages;
    const prefix = m.prefix;

    Object.keys(messages).forEach((key) => {
      const flattenKey = prefix ? `${prefix}.${key}` : key;
      const value = messages[key];

      if (typeof value === "string") {
        result[flattenKey] = value;
      } else {
        stack.push({ messages: value, prefix: flattenKey });
      }
    });
  }

  return result;
}

const ja = flattenMessages(require("./locales/ja.json"));
const en = flattenMessages(require("./locales/en.json"));

export const localizedMessages = {
  ja,
  en: { ...ja, ...en }, // fallback to ja
};

/**
 * NOTE: it is always DEFAULT_LOCALE on SSR; you should not use it!
 */
export const defaultLocale = (
  canUseDOM ? document.querySelector("html")!.getAttribute("lang") || DEFAULT_LOCALE : DEFAULT_LOCALE
) as keyof typeof localizedMessages;

export const createIntl = () => {
  return originalCreateIntl(
    {
      locale: defaultLocale,
      defaultLocale: defaultLocale,
      messages: localizedMessages[defaultLocale],
    },
    createIntlCache(),
  );
};
